import React from 'react';
import { Link } from 'react-router-dom';
import useMain from '../../hooks/useMain';
import Image from '../common/image';
import Shadow from './shadow';

function SuperMarketingPlans() {
	const { theme } = useMain();
	return (
		<>
			<div className='advantages'>
				<div className='container py-5'>
					<div className='container'>
						<div className='row gy-4 align-items-center'>
							<div className='col-md-6 order-2 order-md-1 text-center'>
								<Image
									className='w-75'
									fileName='home/superMarketingPlan.webp'
								/>
							</div>
							<div className='col-md-6 order-1 order-md-2'>
								<h5 className={`text-uppercase text-set5-${theme}`}>
									Unlocking New Income Opportunities
								</h5>
								<h1 className={`fw-bold text-set3-${theme}`}>
									<b>Super Marketing Plan</b>
								</h1>
								<p>
									MMP WORLD's Super Marketing Plan is a revolutionary approach to
									affiliate marketing, offering users the chance to earn income
									through a structured and rewarding system. By participating in
									this plan, users can benefit from various income streams,
									including direct referrals, binary commissions, and development
									bonuses. This multifaceted strategy not only incentivizes active
									participation but also fosters a collaborative community where
									success is shared and amplified.
								</p>
								<p>
									What sets the Super Marketing Plan apart is its emphasis on
									scalability and sustainability. As users build their networks
									and engage with the platform, they unlock higher earning
									potentials and exclusive rewards. This dynamic system is
									designed to adapt to individual growth, ensuring that both
									newcomers and seasoned marketers can maximize their returns.
									With MMP WORLD's Super Marketing Plan, you're not just investing
									in a platform you're becoming part of an ecosystem that values
									and rewards your contribution.
								</p>

								<Link
									to='/dashboard'
									className={`btn btn-set5-${theme} me-3`}>
									Learn More
								</Link>
							</div>
						</div>
					</div>
				</div>
			</div>
			<Shadow />
		</>
	);
}

export default SuperMarketingPlans;
